import { render, staticRenderFns } from "./ServiceProviderDetailsLandingPage.vue?vue&type=template&id=32a851db&scoped=true"
import script from "./ServiceProviderDetailsLandingPage.vue?vue&type=script&lang=js"
export * from "./ServiceProviderDetailsLandingPage.vue?vue&type=script&lang=js"
import style0 from "./ServiceProviderDetailsLandingPage.vue?vue&type=style&index=0&id=32a851db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a851db",
  null
  
)

export default component.exports